<template>
  <el-dialog :title="mode === 'add' ? '新增书签' : '编辑书签'" :visible.sync="visible" width="1200px" @close="handleCancel">
    <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
      <el-form-item label="书签名称" prop="bookmarkName">
        <el-input v-model="form.bookmarkName" placeholder="请输入书签名称" />
      </el-form-item>
      <el-form-item label="书签key" prop="bookmarkKey">
        <el-input v-model="form.bookmarkKey" placeholder="请输入书签key" />
      </el-form-item>
      <el-form-item label="大模型生成规则" prop="bookmarkDescription">
        <el-input type="textarea" :rows="5" v-model="form.bookmarkDescription" placeholder="请输入内容介绍" />
      </el-form-item>
      <el-form-item label="大模型生成示例" prop="bookmarkExample">
        <el-input type="textarea" :rows="5" v-model="form.bookmarkExample" placeholder="请输入内容示例" />
      </el-form-item>
      <el-form-item label="人工维护" prop="isEditable">
        <el-switch v-model="form.isEditable" :active-value="1" :inactive-value="2" active-text="支持" inactive-text="不支持" />
      </el-form-item>
      <el-form-item label="是否单独生成" prop="isLlmGenerateIndependent">
        <el-radio-group v-model="form.isLlmGenerateIndependent">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BookmarkDialog',
  props: {
    visible: Boolean,
    mode: { type: String, default: 'add' }, // add/edit
    bookmark: { type: Object, default: null }
  },
  data() {
    return {
      form: {
        bookmarkName: '',
        bookmarkKey: '',
        bookmarkDescription: '',
        bookmarkExample: '',
        isEditable: 1,
        isLlmGenerateIndependent: 2
      },
      rules: {
        bookmarkName: [ { required: true, message: '请输入书签名称', trigger: 'blur' } ],
        bookmarkKey: [ { required: true, message: '请输入书签key', trigger: 'blur' } ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.mode === 'edit' && this.bookmark) {
          this.form = { isLlmGenerateIndependent: 2, ...this.bookmark }
        } else {
          this.form = {
            bookmarkName: '',
            bookmarkKey: '',
            bookmarkDescription: '',
            bookmarkExample: '',
            isEditable: 1,
            isLlmGenerateIndependent: 2
          }
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.$emit('submit', { ...this.form })
      })
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script> 